import { types } from 'mobx-state-tree';

export default types.model('Image', {
  id: 0,
  url: '/images/missing-image.svg',
});
